import React from 'react';
import { connect } from 'react-redux';

import * as Urls from 'src/constants/EndpointUrls';
import styles from './Report.scss';
import { useTranslation } from 'react-i18next';
import withSetupNeeded from 'src/components/withSetupNeeded';
import compose from 'lodash/fp/compose';

const Report = ({ existPayConfirmed }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.Reports.Report.create_document')}</h1>
      </div>
      <div className="l-wrap-xxl l-contents-wrap">
        <div className="l-overflow-scroll">
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t('features.Reports.Report.category')}</th>
                <th>{t('features.Reports.Report.document_name')}</th>
                <th>{t('features.Reports.Report.submission_period')}</th>
                <th>{t('features.Reports.Report.detailed_description')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.category} rowSpan={2}>
                  {t('features.Reports.Report.data_management')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_ALLOWANCE_DEDUCTIONS_PAY}>{t('components.AllowanceDeductionForm.provision_and_deduction_list')}</a>
                  <p>{t('features.Reports.Report.required_for_monthly_payroll_confirmation')}</p>
                </td>
                <td className={styles.limit}>{t('features.Reports.Report.submission_not_required')}</td>
                <td>
                  {t('features.Reports.Report.You_can_create_a_list_by_selecting_items_such_as_attendance_items_provision_items_deduction_items_It_is_useful_as_a_reference_material_for_payroll_calculation_Also_useful_for_accounting_process_since_the_total_can_be_exported_by_group')}
                </td>
              </tr>
              {/*
              <tr>
                <td className={styles.name}>
                  <a href={Urls.WAGE_LEDGER}>賃金台帳</a>
                  <p>従業員ごとの各月の支給額をまとめたもの</p>
                </td>
                <td className={styles.limit}>
                  役所から開示を<br />求められた時
                </td>
                <td>
                  後に記載した日から起算して3年間の保管義務があります。また、離職票を発行する場合は「雇用保険被保険者離職証明書」や「出勤簿」と合わせてハローワークに提出します。
                </td>
              </tr> 
              */}
              <tr>
                <td className={styles.name}>
                  {existPayConfirmed ? (
                    <a href={Urls.SHOW_PAY_FB_DATA_PAGE_URL}>{t('features.Reports.Report.salary_transfer_list')}</a>
                  ) : (
                    <div>{t('features.Reports.Report.salary_transfer_list')}</div>
                  )}
                  <p>{t('features.Reports.Report.required_for_confirmation_when_transfering_salary')}</p>
                </td>
                <td className={styles.limit}>{t('features.Reports.Report.submission_not_required')}</td>
                <td>{t('features.Reports.Report.you_can_check_the_salary_transfer_amount_and_the_transfer_destination_account_before_salary_transfer')}</td>
              </tr>
              {/* <tr>
                <td className={styles.name}>
                  {values.existBonusConfirmed ? (
                    <a href={Urls.SHOW_BONUS_FB_DATA_PAGE_URL}>賞与振込一覧表</a>
                  ) : (
                    <div>賞与振込一覧表</div>
                  )}
                  <p>賞与振込時に確認するために必要</p>
                </td>
                <td className={styles.limit}>提出不要</td>
                <td>賞与振込前に賞与振込額や振込先口座を確認できます。</td>
              </tr> */}
              {/* <tr>
                <td className={styles.name}>
                  {values.existPayConfirmed ? (
                    <a href={Urls.SHOW_INHABITANT_TAX_FB_PAGE}>住民税一覧表</a>
                  ) : (
                    <div>住民税一覧表</div>
                  )}
                  <p>市区町村ごとに支払う住民税を確認するために必要</p>
                </td>
                <td className={styles.limit}>提出不要</td>
                <td>住民税振込前に住民税振込額や振込先口座を確認できます。</td>
              </tr> */}
              <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.Reports.Report.personal_income_tax')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.INCOME_TAX_DECLARATION_LIST}>{t('features.Reports.Report.personal_income_tax_declaration')}</a>
                  <p>{t('features.Reports.Report.personal_income_tax_declaration_description')}</p>
                </td>
                <td className={styles.limit}>{t('features.Reports.Report.monthly_or_quarterly')}</td>
                <td>{t('features.Reports.Report.personal_income_tax_declaration_details')}</td>
              </tr>
              {/* @TODO: Hide PND1 and Social Security Office Document UI, will be developed for Vietnamese markets later */}
              {/* https://donuts-vn.atlassian.net/browse/JBC-122 */}
              {/* <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.Reports.Report.revenue_department')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_PND_SUMMARY_DATA_PAGE_URL}>{t('features.Reports.Report.pnd1')}</a>
                  <p>{t('features.Reports.Report.Must_be_submitted_to_the_tax_office_every_month')}</p>
                </td>
                <td className={styles.limit}>{t('features.Reports.Report.every_month')}</td>
                <td>{t('features.Reports.Report.You_can_check_employee_income_withholding_tax_and_totals_for_each_office')}</td>
              </tr>
              <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.Reports.Report.social_security_office')} 
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_SSO_DATA_PAGE_URL}>{t('features.Reports.Report.social_security_office')}</a>
                  <p>{t('features.Reports.Report.must_be_submitted_to_the_social_security_office_every_month')}</p>
                </td>
                <td className={styles.limit}>{t('features.Reports.Report.every_month')}</td>
                <td>{t('features.Reports.Report.you_can_check_employee_social_security_contribution_and_totals_for_office')}</td>
              </tr> */}
              {/*
              <tr>
                <td className={styles.category} rowSpan={3}>
                  社会保険
                </td>
                <td className={styles.name}>
                  <a href={Urls.REPORT_MONTHLY_REVISIONS}>月額変更届</a>
                  <p>従業員の給与が大きく変動した時に必要</p>
                </td>
                <td className={styles.limit}>すみやかに</td>
                <td>
                  昇給や降給により固定的賃金が大きく変動した場合、現在の標準報酬月額が実態と乖離してしまうため、年1回の改定前に「月額変更届」を提出する必要があります。<br />
                  詳細は
                  <a
                    href="http://www.nenkin.go.jp/service/kounen/hokenryo-kankei/hoshu/20141104-02.html"
                    className="u-txt-link"
                  >
                    コチラ
                  </a>
                </td>
              </tr>
              <tr>
                <td className={styles.name}>
                  <a href={Urls.REPORT_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS}>算定基礎届</a>
                  <p>年に一度、社会保険の被保険者全員の標準報酬月額を見直すために必要</p>
                </td>
                <td className={styles.limit}>毎年7月10日までに</td>
                <td>
                  社会保険料のベースとなる「標準報酬月額」見直しの手続きです。給与変動の有無に関わらず、年に1回原則すべての被保険者が対象になります。
                </td>
              </tr>
              <tr>
                <td className={styles.name}>
                  {values.existBonusConfirmed ? (
                    <a href={Urls.REPORT_HEALTH_INSURANCE_BONUS_LIST}>賞与支払届</a>
                  ) : (
                    <div>賞与支払届</div>
                  )}
                  <p>賞与支給時に必要</p>
                </td>
                <td className={styles.limit}>賞与支給日から5日以内</td>
                <td>
                  賞与の社会保険料納付のために必要な書類です。提出した賞与支払届を基に、標準賞与額が決まり、保険料額が通知されます。
                </td>
              </tr>
              <tr>
                <td className={styles.category}>労働保険</td>
                <td className={styles.name}>
                  <a href={Urls.REPORT_LABOR_INSURANCE_SUMMARIES}>
                    労働保険の年度更新<br />（算定基礎賃金集計表/労働保険申告書）
                  </a>
                  <p>年間の労働保険料を申告・納付するために必要</p>
                </td>
                <td className={styles.limit}>毎年7月10日までに</td>
                <td>
                  4月1日から翌年3月31日までの1年間を単位として、年度ごとに労働保険料（雇用保険料＋労災保険料）を申告・納付するための手続きです。<br />前年度の確定した労働保険料と、今年度の見込み分の労働保険料を、労働基準監督署などに申告し、納付する必要があります。
                </td>
              </tr>
              <tr>
                <td className={styles.category}>税・年末調整</td>
                <td className={styles.name}>
                  <a href={Urls.REPORT_WITHHOLDING_SLIP_LIST}>源泉徴収票</a>
                  <p>1月1日から12月31日までに支払われた給与等の支払金額や所得税などが記載されたもの</p>
                </td>
                <td className={styles.limit}>
                  翌年の1月31日まで<br />
                  （退職者に配布する場合は退職後1ヶ月以内）
                </td>
                <td>
                  <p>
                    ■受給者交付用<br />
                    1月1日から12月31日の間に給与・賞与を支給したすべての従業員に配布する必要があります。年末調整後や退職時に配布します。
                  </p>
                  <br />
                  <p>
                    ■税務署提出用<br />
                    給与等の年間支給額などが150万円超の役員や500万円超の従業員など
                    <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/hotei/7411.htm" className="u-txt-link">
                      一定の要件
                    </a>
                    を満たした方のみ、税務署への提出が必要になります。
                  </p>
                </td>
              </tr> 
              */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default compose(withSetupNeeded('to_start_document_section'), connect())(Report);
